/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Deduct_On_PackingInputs */

const vi_packaging_material_deduct_on_packing = /** @type {(inputs: Packaging_Material_Deduct_On_PackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khi đóng gói sản phẩm`)
};

/**

* @param {Packaging_Material_Deduct_On_PackingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_deduct_on_packing = /** @type {((inputs?: Packaging_Material_Deduct_On_PackingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Deduct_On_PackingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_deduct_on_packing(inputs)
});